module.exports = __webpack_public_path__ + "img/bullets-400.9c842539.png";